import { Deserializable } from './deserializable';

export class Deviation implements Deserializable {
    caseId: string;
    createdBy: {
      email: string;
      firstName: string;
      fullName: string;
      lastName: string;
      name: string;
    };
    createdOn: string;
    caseNumber: number;
    deviationId: number;
    deviationComment: string;
    lastOccurrence: Date;
    siteEventTime: Date;
    status: string;
    tagAlias: any;
    title: string;
    trainAssemblyId: number;
    trainId: number;
    trainName: string;
    salesForceEquipmentId: string;
    technology: string;

    tagAliasArray: any;
    tagString: string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/models/deviation.ts